module.exports = __webpack_public_path__ + "static/media/VideoHangboard.87115196.gif";